var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwipeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00094 7.82855H17.0009V9.61855C17.0009 10.0686 17.5409 10.2886 17.8509 9.96855L20.6409 7.17855C20.8409 6.97855 20.8409 6.66855 20.6409 6.46855L17.8509 3.67855C17.5409 3.36855 17.0009 3.58855 17.0009 4.03855V5.82855H6.00094C5.45094 5.82855 5.00094 6.27855 5.00094 6.82855V10.8286C5.00094 11.3786 5.45094 11.8286 6.00094 11.8286C6.55094 11.8286 7.00094 11.3786 7.00094 10.8286V7.82855ZM17.0009 17.8286H7.00094V16.0386C7.00094 15.5886 6.46094 15.3686 6.15094 15.6886L3.36094 18.4786C3.16094 18.6786 3.16094 18.9886 3.36094 19.1886L6.15094 21.9786C6.46094 22.2886 7.00094 22.0686 7.00094 21.6186V19.8286H18.0009C18.5509 19.8286 19.0009 19.3786 19.0009 18.8286V14.8286C19.0009 14.2786 18.5509 13.8286 18.0009 13.8286C17.4509 13.8286 17.0009 14.2786 17.0009 14.8286V17.8286Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeWhite);
export default __webpack_public_path__ + "static/media/swipeWhite.d5e3bfba7395f33a39945f022b489209.svg";
export { ForwardRef as ReactComponent };